import type {
  ControllerPlacementCandidate,
  ControllerPlacementCandidateInfo,
  ControllerPlacementCandidateTable,
} from "building-types/electrical/candidate";
import { controllerPlacementCandidateInfoNew } from "building-types/electrical/candidate";

export function addCandidateToTable(
  candidate: ControllerPlacementCandidate,
  candidateTable: ControllerPlacementCandidateTable,
  setIndex: number,
): ControllerPlacementCandidateInfo {
  const candidates: ControllerPlacementCandidateInfo[] = candidateTable[setIndex] ?? [];
  const candidiateInfo = controllerPlacementCandidateInfoNew(candidate);
  candidates.push(candidiateInfo);
  candidateTable[setIndex] = candidates;

  return candidiateInfo;
}
